import axios from "axios";
import authHeader from './auth-header';
import { API_URL } from '../common/globalvars'

export default axios.create({
  baseURL: API_URL,
  headers: authHeader()
});
